
<ng-select
  *ngIf="user?.isAdmin"
  [(ngModel)]="selectedInstanceId"
  (change)="switchInstance($event)"
  bindLabel="name"
  bindValue="id"
  [clearable]="false"
  [items]="instances" class="mw-md"
  >
</ng-select>
